import { Link } from "react-router-dom";
import { ArrowLeft, FileText, Download, Scale, Info } from "lucide-react";

export default function Trasparenza() {
  return (
    <div className="min-h-screen bg-[#FBF9F6]" data-testid="trasparenza-page">
      <header className="bg-[#1f2d22] text-white py-8 sm:py-10 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-white/65 hover:text-white mb-5"
            data-testid="trasparenza-back"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla home
          </Link>
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-4">
            <Scale className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              Pagina ufficiale dell'associazione
            </span>
          </div>
          <h1
            data-testid="trasparenza-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black leading-tight tracking-tight"
          >
            Trasparenza e Documenti
          </h1>
          <p className="mt-4 text-white/75 text-base sm:text-lg max-w-2xl leading-relaxed">
            In questa sezione raccogliamo i documenti pubblici dell'associazione
            Per Asciano in piena trasparenza verso cittadini e sostenitori.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-12 sm:py-16 space-y-10">
        {/* Statuto */}
        <section
          data-testid="statuto-section"
          className="bg-white border-2 border-[#E5E1D8] rounded-3xl p-7 sm:p-9 shadow-sm"
        >
          <div className="flex items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-[#2E4F3B] text-white flex items-center justify-center shrink-0">
              <FileText className="w-7 h-7" />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A] leading-tight">
                Statuto dell'Associazione
              </h2>
              <p className="mt-3 text-base text-[#5C5C5C] leading-relaxed">
                Il documento ufficiale che disciplina la vita e le finalità
                dell'Associazione Per Asciano.
              </p>
              <div className="mt-5 flex flex-wrap gap-3">
                <a
                  href="/documenti/statuto-per-asciano.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="statuto-view-btn"
                  className="inline-flex items-center gap-2 rounded-full bg-[#1A1A1A] hover:bg-[#2E4F3B] text-white font-semibold text-sm px-5 py-2.5 transition-colors"
                >
                  <FileText className="w-4 h-4" />
                  Apri PDF
                </a>
                <a
                  href="/documenti/statuto-per-asciano.pdf"
                  download
                  data-testid="statuto-download-btn"
                  className="inline-flex items-center gap-2 rounded-full bg-white border-2 border-[#E5E1D8] hover:border-[#1A1A1A] text-[#1A1A1A] font-semibold text-sm px-5 py-2.5 transition-colors"
                >
                  <Download className="w-4 h-4" />
                  Scarica
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Bilanci */}
        <section
          data-testid="bilanci-section"
          className="bg-white border-2 border-[#E5E1D8] rounded-3xl p-7 sm:p-9 shadow-sm"
        >
          <div className="flex items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-[#C15C3D] text-white flex items-center justify-center shrink-0">
              <Info className="w-7 h-7" />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A] leading-tight">
                Bilanci e rendiconti
              </h2>
              <p className="mt-3 text-base text-[#5C5C5C] leading-relaxed">
                L'associazione è stata costituita recentemente.
              </p>
              <p className="mt-2 text-base text-[#5C5C5C] leading-relaxed">
                I rendiconti economici e gli eventuali bilanci saranno
                pubblicati secondo quanto previsto dalla normativa vigente e
                dallo statuto associativo.
              </p>
            </div>
          </div>
        </section>

        {/* Dati associazione */}
        <section
          data-testid="dati-section"
          className="bg-[#1f2d22] text-white rounded-3xl p-7 sm:p-9"
        >
          <h2 className="font-display text-xl sm:text-2xl font-black mb-5">
            Dati dell'associazione
          </h2>
          <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-4 text-sm sm:text-base">
            <div>
              <dt className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E8C9A0] mb-1">
                Denominazione
              </dt>
              <dd>Associazione Per Asciano</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E8C9A0] mb-1">
                Codice Fiscale
              </dt>
              <dd className="font-mono">93104860502</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E8C9A0] mb-1">
                Sede
              </dt>
              <dd>Asciano (PI) · Toscana</dd>
            </div>
            <div>
              <dt className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#E8C9A0] mb-1">
                Email
              </dt>
              <dd>
                <a
                  href="mailto:perasciano@gmail.com"
                  className="hover:text-[#E8C9A0]"
                >
                  perasciano@gmail.com
                </a>
              </dd>
            </div>
          </dl>
        </section>
      </main>
    </div>
  );
}
